import Radio from '@visa/vds/radio';
import RadioGroup from '@visa/vds/radio-group';
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import React from "react";
import { ProductSelectionConst } from "../SelectProduct/ProductSelectionLogic";

const FeeWaiverComponent = (props) => {
  const handleChange = (e) => {
    props.setSelectedFeeWaiverId(parseInt(e.target.value));
  };

  const shouldShowFeeWaiver = () => {
    return props.filteredFeeWaiverOptions.length > 0;
  };

  return (
    shouldShowFeeWaiver() ? 
    <>
        <Typography tag="h2">Fee Waiver or Fee Discount</Typography>
        <Row>
          <Typography tag="h4">
            {props.selectedCategory == ProductSelectionConst.VSTS_CATEGORY 
              ? "There is a VSTS Fee Waiver or Fee Discount available, please select the Fee Waiver or Fee Discount that you want to apply:" 
              : "Visa offers a limited VSTT Fee Waiver and Fee Discount. Please select the one fee option that you want to apply to your subscription order.  The VSTT DAF Fee Waiver or Fee Discount is offered for only one VSTT subscription to 3DS Product Providers. VSTT annual subscriptions are not eligible for a VSTT Fee Waiver or Fee Discount."
            }
            
          </Typography>
          <Row>
            <RadioGroup
                className="radio-group-feewaiver">
                {props.filteredFeeWaiverOptions.map((item, index) => {
                    return (
                        <Radio
                            id={item.description + " radio-btn"}
                            key={index}
                            checked={props.selectedFeeWaiverId === item.productId}
                            onChange={handleChange}
                            name="radio-feewaiver-select"
                            value={item.productId}
                            label={item.description}
                        />
                    )
                })}
                <Radio
                    id="no-fee-waiver-radio-btn"
                    default
                    checked={props.selectedFeeWaiverId === 0}
                    onChange={handleChange}
                    name="radio-feewaiver-select"
                    value={0}
                    label="I do not want to apply any Fee Waiver or Fee Discount."
                />
            </RadioGroup>
        </Row>
        </Row>
    </>
    : <></>
  );
};

export default FeeWaiverComponent;
